import type { ObservationsBatchEditSeverityProps } from "./observations-batch-edit-severity.type";

import { useTranslation } from "react-i18next";

import BatchEditForm from "@/modules/batch-edit-form";
import { StaticFieldSelect } from "@/ui/static-field-select";

import { useObservationsBatchEditSeverity } from "./observations-batch-edit-severity.hook";

const ObservationsBatchEditSeverity = ({
  observations,
}: ObservationsBatchEditSeverityProps) => {
  const { t } = useTranslation();
  const {
    form,
    fieldName,
    initialValue,
    onFormChange,
    onFormSubmit,
    hasChanges,
    hasError,
    isPending,
  } = useObservationsBatchEditSeverity(observations);

  return (
    <BatchEditForm
      modelKey="observation"
      form={form}
      fieldName={fieldName}
      initialValue={initialValue}
      onFormChange={onFormChange}
      onFormSubmit={onFormSubmit}
      hasChanges={hasChanges}
      isPending={isPending}
      hasError={hasError}
      customErrorMessages={[t("observation:batchEditSeverity.formError")]}
    >
      <StaticFieldSelect type="severity" name={fieldName} />
    </BatchEditForm>
  );
};

export default ObservationsBatchEditSeverity;
